export function getDomainAndPort() {
  return (() => {
    let a = window.location.host.split("."),
      b = a.length;
    return a[b - 2] + "." + a[b - 1];
  })();
}

// TODO: Use actual endpoints, this will probalby need to be computed.
export const CFG_GENERIC = {
  configValuesUrl:
    "https://landing-assistant.dev.protodeal.com/2015-03-31/functions/function/invocations",
};

// TODO: Use actual endpoints, this will probalby need to be computed.
export const CFG_ENDPOINTS = {
  // Lead intake lambda (reemplaza a api.tradeando.net/ajax/contact para
  // funnels Protodeal; en dev publica a la cola de test del infoproducto 32)
  LeadCreationEndpoint:
    "https://lead.dev.protodeal.com/2015-03-31/functions/function/invocations",
  WebAnalyticsEventEndpoint:
    "https://events.dev.protodeal.com/2015-03-31/functions/function/invocations",
  VslServingEndpoint:
    "https://vsl-serving.dev.protodeal.com/2015-03-31/functions/function/invocations",
  CalendlyScheduledEventEndpoint:
    "https://calendly-data.dev.protodeal.com/2015-03-31/functions/function/invocations",
};
